<template>
  <div class="form-group" :class="{'input-group': hasIcon}">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{label}}
      </label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-addon">
        <i :class="addonLeftIcon"></i>
      </span>
    </slot>
    <div v-if="!value" style="display:flex;">
      <label class="btn btn-default btn-file form-control"
        v-if="!disabled"
        style="margin: 0px;">
        Seleziona file
        <input
          style="display: none;"
          @change="onFileChange"
          v-bind="$attrs"
          type="file"
          accept="image/*;capture=camera"
          class="form-control"
          aria-describedby="addon-right addon-left">
      </label>
      <label class="btn btn-default btn-file form-control"
        v-if="!disabled && isApp"
        style="margin: 0px 0px 0px 10px;"
        @click.prevent="scattaFoto()">
        Scatta foto
      </label>
      <div class="form-control" v-if="disabled" disabled>
        Nessun file
      </div>
    </div>
    <div v-else>
      <label>
        <button @click.prevent="showImage" class="btn btn-info form-control">Visualizza</button>
      </label>
      <label v-if="!disabled">
        <button @click.prevent="removeImage" class="btn btn-info form-control">Rimuovi</button>
      </label>
    </div>
    <slot></slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-image',
    data () {
      return {
        visualizzaImg: false,
        changed: false
      }
    },
    props: {
      disabled: Boolean,
      label: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String
    },
    methods: {
      onFileChange (e) {
        var files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.createImage(files[0])
      },
      createImage (file) {
        var reader = new FileReader()
        var me = this
        reader.onload = (e) => {
          this.$data.changed = true
          me.$emit('input', e.target.result)
        }
        reader.readAsDataURL(file)
      },
      showImage: function (e) {
        var src
        if (this.$data.changed) {
          src = this.$props.value
        } else {
          src = this.$root.imgUrl(this.$props.value)
        }
        this.$root.showModal('<div style="width:100%;height:100%;overflow:auto;text-align:center; padding:5px;"><img :src="value" width="100%"/></div>', {
          value: src
        })
      },
      removeImage: function (e) {
        this.$emit('input', '')
      },
      scattaFoto: function () {
        var me = this
        var camera = me.$root.cordova.camera
        camera.getPicture((imageData) => {
          var data = 'data:image/jpeg;base64,' + imageData
          me.$data.changed = true
          me.$emit('input', data)
        }, (message) => {
          me.$root.errorMessage('Errore fotocamera: ', message)
        }, {
          quality: 50,
          destinationType: camera.DestinationType.DATA_URL
        })
      }
    },
    computed: {
      hasIcon () {
        const {addonRight, addonLeft} = this.$slots
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      },
      isApp () {
        return this.$root.isApp
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/formGroupImage.vue